import React from 'react';
export async function loader({ params }) {

    return null;
   // return { };
}

export default function SumUpPaymentSuccess() {
   

    return (
        <div className="endPayment">
            <div id="thumbnail">


                <div className="depositSuccess">

                    <h2>Le paiement à échoué !</h2>
                 
                    <i className="pi pi-check-circle" style={{ fontSize: '3rem' }}></i>
                </div>
                

            </div>

        </div>
        
    )            
}